import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.less";
import ReactGA from "react-ga4";
import "./styles/index.scss";
import App from "./core/App";
import * as serviceWorker from "./serviceWorker";
import userService from "src/shared/services/user.service";
import joyrideService from "src/shared/services/joyride.service";
import createStore from "src/core/store";
import { createStoreContext } from "src/shared/hooks";
import ErrorBoundary from "src/shared/components/ErrorBoundary";

const store = createStore();
const { Provider } = createStoreContext<any>();

/**
 * the below code is to calculate the actual displayable height which
 * excludes the bottom toolbar in the  mobile browsers and programatically
 * reset the ViewPort height.
 **/
const vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

userService.setTokenFromStorage();
joyrideService.incrementVisitedCount();

function initializeReactGA() {
  if (userService.userInfo && userService.userInfo.username) {
    let userId = "unknown";
    try {
      // Not foolproof solution. multiple users can have same user name
      // Fix: ask backend to send user ids
      if (userService.userInfo.username) userId = btoa(userService.userInfo.username);
    } catch (error) {
      console.error(error);
    }
    // eslint-disable-next-line no-console
    console.log("getting GA id from env", process.env.ANOBIS_UI_GA_ID);
    try {
      ReactGA.initialize(process.env.ANOBIS_UI_GA_ID || "G-ZPWEG8C40C");
    } catch (error) {
      console.error("error initializing GA", error);
    }

    ReactGA.set({ dimension1: userId });
  }
}

initializeReactGA();

ReactDOM.render(
  <ErrorBoundary fallback={<div>Something went wrong</div>}>
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>,
  document.getElementById("root")
);

if (module.hot) {
  module.hot.accept();
}

if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const whyDidYouRender = require("@welldone-software/why-did-you-render");
  whyDidYouRender(React, {
    onlyLogs: true,
    logOnDifferentValues: false,
    titleColor: "mediumpurple",
    diffNameColor: "orange",
    diffPathColor: "crimson",
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
if (window.location.href.includes("anobis.swiggy.com")) {
  serviceWorker.register({
    onUpdate(registration) {
      const snackbar = document.getElementById("snackbar");
      if (snackbar) {
        snackbar.className = "show";
      }
    },
    onInstalled(installingWorker) {
      const reloadEl = document.getElementById("reload-sw");
      reloadEl &&
        reloadEl.addEventListener("click", function () {
          installingWorker.postMessage({ type: "SKIP_WAITING" });
          window.location.reload();
        });
    },
  });
} else {
  serviceWorker.unregister();
}
